module.exports = __webpack_public_path__ + "media/images/lb/255-503cbc5e199faf0261d4e8652ab9990a.svg";